import React from 'react';
import {graphql, createFragmentContainer} from 'react-relay';
import {withRouter} from 'react-router-dom';
import {TableRow, TableRowColumn} from 'material-ui/Table';
import moment from 'moment';

import streamStyle from './stream-style';
import './stream-style.css';
import {streamStates} from '../../lib/config';

const StreamListItem = ({stream, history}) => {
    const parseData = data => {
        const states = streamStates.filter(e => e.value === data.state);
        const stateText = states.length > 0 ? states[0].primaryText : 'Неизвестен';

        return {
            id: data.id,
            title: data.title,
            date: data.availableAt,
            statusPrev: data.active,
            status: stateText,
        };
    };

    const item = parseData(stream);

    return (
        <TableRow
            onClick={() => history.push(`/stream/${item.id}`)}
            style={{ border: 0 }}
        >
            <TableRowColumn style={{ ...streamStyle.columnDate, fontSize: 14, paddingLeft: 20 }}>
                {moment(item.date).format('HH:mm')}
                <br />
                {moment(item.date).format('DD.MM.YYYY')}
            </TableRowColumn>
            <TableRowColumn style={{
                ...streamStyle.columnTitle,
                ...streamStyle.columnCell,
                fontSize: 14,
            }}
            >
                <div className="stream-table--title">{item.title}</div>
            </TableRowColumn>
            <TableRowColumn style={{ ...streamStyle.columnStatus, fontSize: 14 }}>
                {item.status}
            </TableRowColumn>
        </TableRow>
    );
};

export default withRouter(createFragmentContainer(StreamListItem, {
    stream: graphql`
        fragment StreamListItem_stream on Stream {
            id,
            title,
            state,
            availableAt
        }
    `,
}));



// WEBPACK FOOTER //
// src/components/streams/StreamListItem.js